import React, { useState } from 'react';
import Buttons from '../Buttons/Buttons';
import menuwords from './menuDictionary';
import { languageSwitch } from '../../dictionary/translateFunctions';
import './menu.css';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { cvDownload, cvDownload_en } from '../../conexiones/varConexiones';
import { Button } from 'react-scroll';
import LangSwitch from '../languageSwitch/langSwitch.js';

const Menu = (props) => {
    const lang = useSelector((state) => state.lang.lang);
    const dictionary = menuwords;

    const [position,setPosition] = useState('home')
    const resumFunc = () => {
        const link = document.createElement("a");
        const ruta = lang === 'es' ? cvDownload : cvDownload_en;
        link.href = ruta;
        link.download = "";   // permite descargar el archivo
        link.target = "_blank";
        link.click();
    }
    return(
        <div id="menu_options" className="header_menu">
            <ul id="menu_options" className="header_menu_options">
                <Link className='Link' to="/Home"><Buttons onClick={()=>setPosition('home')} type={'ghost'} cta={languageSwitch(dictionary.ht0,lang)} /></Link>
                <Link className='Link' to="/Home"><Buttons onClick={props.scroll} type={'ghost'} cta={languageSwitch(dictionary.ht1,lang)} /></Link>
                <Link className='Link' to="/About"><Buttons onClick={()=>setPosition('about')} type={'ghost'} cta={languageSwitch(dictionary.ht2,lang)} /></Link>
                <Link className='Link' to="/Contacto"><Buttons onClick={()=>setPosition('contact')} type={'ghost'} cta={languageSwitch(dictionary.ht3,lang)} /></Link>
                <Buttons onClick={()=>resumFunc()} type={'secondary'} cta={languageSwitch(dictionary.ht4,lang)} />
            </ul>
            <LangSwitch/>
        </div>
    )
}

export default (Menu);